<template>
  <v-form>
    <v-container fluid>
      <v-row>


        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="profileParameterSelectItems"
            v-model="item.profileParameter"
            :items="profileParameterSelectItems"
            :error-messages="profileParameterErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.profileparameter.profileparameter')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.value"
            :error-messages="valueErrors"
            :label="$t('profile.profileparameter.value')"
            required
            @input="$v.item.value.$touch()"
            @blur="$v.item.value.$touch()"
          />
        </v-col>

        <v-col cols="12"></v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'ProfileParameterSetValueForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.profileParameterSetGetSelectItems();
      this.profileParameterGetSelectItems();
  },
  data() {
    return {
        profileParameterSet: null,
        profileParameter: null,
        value: null,
    };
  },
  computed: {
      isLoading() {
        return (this.isLoading_profileparameterset ||
           this.isLoading_profileparameter 
         );
      },
      ...mapFields('profileparameterset', {
        profileParameterSetSelectItems: 'selectItems',
        isLoading_profileparameterset : 'isLoading'
      }),
      ...mapFields('profileparameter', {
        profileParameterSelectItems: 'selectItems',
        isLoading_profileparameter : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    profileParameterSetErrors() {
      const errors = [];

      if (!this.$v.item.profileParameterSet.$dirty) return errors;

      has(this.violations, 'profileParameterSet') && errors.push(this.violations.profileParameterSet);


      return errors;
    },
    profileParameterErrors() {
      const errors = [];

      if (!this.$v.item.profileParameter.$dirty) return errors;

      has(this.violations, 'profileParameter') && errors.push(this.violations.profileParameter);


      return errors;
    },
    valueErrors() {
      const errors = [];

      if (!this.$v.item.value.$dirty) return errors;

      has(this.violations, 'value') && errors.push(this.violations.value);

      !this.$v.item.value.required && errors.push(this.$t('global.field_required'));

      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        profileParameterSetGetSelectItems: 'profileparameterset/fetchSelectItems'
      }),
      ...mapActions({
        profileParameterGetSelectItems: 'profileparameter/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      profileParameterSet: {
      },
      profileParameter: {
      },
      value: {
        required,
      },
    }
  }
};
</script>
